import { FC } from 'react';
import { Severity } from '@splunk/olly-react-ui/lib/SeverityIcon/types';
import { SeverityIcon as SeverityIconComponent } from '@splunk/olly-react-ui/lib/SeverityIcon/SeverityIcon';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../theme/ThemeProvider';

type SeverityIconProps = {
    severity: Severity;
};

export const SeverityIcon: FC<SeverityIconProps> = ({ severity }) => {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <SeverityIconComponent severity={severity} />
        </ThemeProvider>
    );
};
